import { render, staticRenderFns } from "./DHME.ModuleDashboard.vue?vue&type=template&id=e4a4b134&scoped=true"
import script from "./DHME.ModuleDashboard.vue?vue&type=script&lang=js"
export * from "./DHME.ModuleDashboard.vue?vue&type=script&lang=js"
import style0 from "./DHME.ModuleDashboard.vue?vue&type=style&index=0&id=e4a4b134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a4b134",
  null
  
)

export default component.exports